export default __webpack_public_path__ + "static/media/8.ace674d0.svg";